<template>
  <span class="workstatus">{{ text}}</span>
</template>
<script>
export default {
  props: ["text"],
  data() {
    return {

    };
  },
};
</script>
<style lang="">
.workstatus {
  font-size: 10px !important;
  font-weight: lighter;
  padding: 0px 4px;
  line-height: 12px;
  position: relative;
  top: -2px;
  background: #d5e5f7;
  border: solid 1px #2881da;
}
</style>


// WEBPACK FOOTER //
// src/components/common/workStatus.vue